import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as portalContactActions from '../../actions/portal-contact/portalContactActions';
import PortalContactTable from "./PortalContactTable";
import PortalContactDivs from "./PortalContactDivs";
import * as modalActions from '../../actions/common/modalActions';
import CustomModal from '../../components/CustomModal.jsx';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import { toastr } from 'react-redux-toastr';
import CustomPagination from '../../components/common/CustomPagination';
import BaseList from "../common/list/BaseList";
import SearchBarContainer from '../common/searchbar/SearchBarContainer';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import * as userActions from "../../actions/userActions";
import * as sortableListActions from "../../actions/common/sortableListActions";
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderError from "../common/PlaceholderError";
import PlaceholderTable from "../common/PlaceholderTable";

class CompaniesListContainer extends BaseList {
    constructor(props) {
        super(props);
        this.onDelete = this.onDelete.bind(this);
        this.listId = 'portal-contacts';
        this.state = {
            page: 1,
            searchText: '',
            actions: this.getRequiredActions()
        };
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.sortParamWasChanged(nextProps)) {
            nextState.page = 1;
        }
    }


    getRequiredActions() {
        return [
            this.props.actions.loadPortalContacts(1)
        ]
    }

    componentWillUnmount() {
        this.props.actions.resetList(this.listId);
    }

    onDelete(id) {
        this.deletePortalContactId = id;
        this.props.actions.showModal();
    }

    deleteContact(id) {
        if(!this.deletePortalContactId) {
            toastr.error(this.props.intl.formatMessage(messages.portalContactDeleteError));
            this.props.actions.hideModal();
            return;
        }

        this.props.actions.deletePortalContact(this.deletePortalContactId).then(() => {
            this.deletePortalContactId = null;
            this.props.actions.loadPortalContacts(this.state.page);
            this.props.actions.hideModal();
            toastr.success(this.props.intl.formatMessage(messages.portalContactDeleted));
        });
    }

    hideDeleteModal() {
        this.deletePortalContactId = null;
        this.props.actions.hideModal();
    }

    onPageChange(addActions, pageNum) {
        let page = pageNum.selected + 1;
        let promise = this.props.actions.loadPortalContacts(page, this.getSortParams(this.props));
        addActions([promise]);
        this.setState({page});
    }

    render() {
        let contacts = this.props.contacts.data || [];

        return (
            <WithResolvedPromises promises={this.state.actions} preloaderComponent={PlaceholderTable} errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return(
                            <div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-block">
                                                <div className="row">
                                                    <div className="col-6"><h1>{this.props.intl.formatMessage(messages.portalContacts)}</h1></div>
                                                    <div className="col-sm-6 pt-2">
                                                        <Link to="/portal-kontakt/skab"
                                                              className="btn btn-primary waves-effect pull-right">{this.props.intl.formatMessage(messages.portalContactCreate)}
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6 offset-6">
                                                        <SearchBarContainer listId={this.listId} loadDataAction={portalContactActions.loadPortalContacts} />
                                                    </div>
                                                </div>
                                                <MediaQuery query='(max-device-width: 768px)'>
                                                    <PortalContactDivs
                                                        contacts={contacts}
                                                        onDelete={this.onDelete}
                                                    />
                                                </MediaQuery>
                                                <MediaQuery query='(min-device-width: 769px)'>
                                                    <PortalContactTable
                                                        contacts={contacts}
                                                        onDelete={this.onDelete}
                                                        listId={this.listId}
                                                    />
                                                </MediaQuery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <CustomPagination
                                        total={this.props.contacts.total}
                                        page={this.state.page}
                                        onPageChange={this.onPageChange.bind(this, addActions)}
                                    />
                                </div>
                                <CustomModal
                                    modalTitle={this.props.intl.formatMessage(messages.portalContactDeleteModalTitle)}
                                    modalContent={<p>{this.props.intl.formatMessage(messages.portalContactDeleteQuestion)}</p>}
                                    confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                                    closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                                    handleConfirm={() => {this.deleteContact()}}
                                    handleHideModal={() => {this.hideDeleteModal()}}
                                    isOpen={this.props.showModal}
                                />
                            </div>
                        );
                    }
                }
            </WithResolvedPromises>
        );
    }
}

function mapStateToProps(state) {
    return {
        contacts: state.portalContacts,
        showModal: state.showModal,
        sortableList: state.sortableList,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...portalContactActions,
                ...modalActions,
                ...sortableListActions,
            }, dispatch
        )
    }

}


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CompaniesListContainer));


// WEBPACK FOOTER //
// ./web/src/components/portal-contact/PortalContactTableContainer.jsx